/**
 * Apple Ads：红线规则配置 API 服务（CLAUDE.md §前端 API 服务层 — 按域分目录）。
 *
 * 与后端 Pydantic 模型 apple_asa.dtos.redline_config 对齐。
 *   - GET  /api/v1/apple-asa/redline-config          → 全表读
 *   - PUT  /api/v1/apple-asa/redline-config          → 保存（upsert 一批行）
 *   - POST /api/v1/apple-asa/redline-config/seed     → 空表种入 2 行初版
 */

import { request } from "../apiClient";

/** Apple Ads 红线规则配置行（与后端 AppleRedlineConfigItem 对齐）。 */
export interface AppleRedlineConfigItem {
  field: string;
  parent_id: string;
  child_id: string;
  ope_value: string;
}

/** Apple Ads 红线规则配置行（含审计列，与后端 AppleRedlineConfigRecord 对齐）。 */
export interface AppleRedlineConfigRecord extends AppleRedlineConfigItem {
  create_user?: string | null;
  modify_user?: string | null;
  created_time?: string | null;
  updated_time?: string | null;
}

export interface SaveAppleRedlineConfigBody {
  rows: AppleRedlineConfigItem[];
}

/** 获取全部 Apple Ads 红线规则配置（按 field/parent_id/child_id 排序）。 */
export async function getAppleRedlineConfig(): Promise<AppleRedlineConfigRecord[]> {
  const data = await request<AppleRedlineConfigRecord[] | null>(
    "/api/v1/apple-asa/redline-config",
  );
  return data ?? [];
}

/** 保存（upsert）一批 Apple Ads 红线配置行；返回保存后全表（含更新后的审计列）。 */
export async function saveAppleRedlineConfig(
  body: SaveAppleRedlineConfigBody,
): Promise<AppleRedlineConfigRecord[]> {
  const data = await request<AppleRedlineConfigRecord[] | null>(
    "/api/v1/apple-asa/redline-config",
    { method: "PUT", body },
  );
  return data ?? [];
}

/** 空表时种入 2 行初版 Apple Ads 红线配置；返回本次种入行数（非空表返回 0）。 */
export async function seedAppleRedlineConfig(): Promise<number> {
  const data = await request<{ seeded: number } | null>(
    "/api/v1/apple-asa/redline-config/seed",
    { method: "POST" },
  );
  return data?.seeded ?? 0;
}
